import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { getSessionState } from '@client/selectors';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class IsEmailVerifiedGuard implements CanActivate {
	constructor(private store: Store<any>, private router: Router) {}

	canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return this.store.pipe(
			select(getSessionState),
			map(u => !!u.uid && u.emailVerified)
		);
	}
}
